/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { ProtocolSectionArgs } from "../../base-components/base-protocol-item";
export default class TreatmentHistoryDefaultTargetedTherapyComponent extends Component {
  get targetedTherapyTypes() {
    switch (this.args.followUpReasonId) {
      case "onco-pancreatic-cancer":
        return ["olaparib-300", "olaparib-250", "olaparib-200", "olaparib-150", "olaparib-100"];
      default:
        return ["herceptin", "avastin", "perjeta", "kadcyla", "tyverb"];
    }
  }
}